// extracted by mini-css-extract-plugin
export default {"root":"test-warning_root__txsby","content":"test-warning_content__hmGe8"};